import {DEFAULT_DATASET} from './datasets.js';
import {
  getFeatureReference,
  getLink,
  parseReference,
  referenceToUrl,
} from './util.js';
import {graneroInstance, processAPIInstance} from './index.js';

/**
 * Provides methods for working with Granero features.
 * @module api/features
 */

export const getFeatures = (collectionId, options) => {
  const {dataset = DEFAULT_DATASET, params, ...otherOptions} = options || {};

  const config = {
    params: params || {},
    ...otherOptions,
  };

  if (!config.params.limit) {
    config.params.limit = 250;
  }

  return graneroInstance
    .get(`/ogc/${dataset}/collections/${collectionId}/items/`, config)
    .then(res => res.data);
};

export const getFeatureByReference = (reference, options) => {
  const parsed = parseReference(reference);

  let url = `/ogc/${parsed.dataset}/collections/${parsed.collectionId}/items/${parsed.featureId}`;

  if (parsed.version) {
    url = `${url}/versions/${parsed.version}`;
  }
  // return the features
  return graneroInstance.get(url, options).then(r => r.data);
};

export const addFeatureToCollection = (collectionId, feature, options) => {
  const {dataset = DEFAULT_DATASET, ...config} = options || {};

  return graneroInstance
    .post(`/ogc/${dataset}/collections/${collectionId}/items/`, feature, config)
    .then(res => res.data);
};

export const updateFeature = (feature, options) => {
  const config = options || {};

  const featureRef = getFeatureReference(feature);
  const featureHref = featureRef
    ? referenceToUrl(featureRef)
    : getLink(feature, 'self');

  if (!featureHref) {
    throw new Error('Feature is missing `links` and no short ref provided.');
  }

  return graneroInstance
    .put(featureHref, feature, config)
    .then(res => res.data);
};

/**
 *
 * @param {Array} references - Array of short URLs
 * @returns {Array} - Array of geojson features
 */
export const getFeaturesByReferences = (references, options) => {
  if (!Array.isArray(references)) {
    throw new Error('References must be of type Array');
  }

  const url = `/process/multifetch/execution`;

  // return the features
  return processAPIInstance.post(url, references, options).then(r => r.data);
};

export const getFeaturesUnionByReferences = (references, options) => {
  if (!Array.isArray(references)) {
    throw new Error('References must be of type Array');
  }

  const url = `/process/union/execution`;

  // return the features
  return processAPIInstance.post(url, references, options).then(r => r.data);
};

export const deleteFeature = (featureRef, options) => {
  const href = referenceToUrl(featureRef);

  return graneroInstance.delete(href, options).then(res => res.data);
};
